import { determineWidthBreakpointMin, ScreenWidth } from '@app/styles/scripts/uiHelpers';
import {
    NAVBAR_HEIGHT,
    NAVBAR_MARGIN,
    TIME_FILTER_HEIGHT,
    TIME_FILTER_MARGIN,
} from '@app/styles/elementConstants';

export const FIRST_ROW_OFFSET = NAVBAR_HEIGHT + NAVBAR_MARGIN + TIME_FILTER_HEIGHT + TIME_FILTER_MARGIN;

export function getBannersHeight(
    options: { promotionBanners: Object[], quickLinkBanners: Object[] | null },
    bannerHeights: BannersHeights,
) {
    let offset = 0;
    if (options && options.promotionBanners && options.promotionBanners.length) {
        offset += bannerHeights.promotionBanner;
    }
    if (options && options.quickLinkBanners && options.quickLinkBanners.length) {
        offset += bannerHeights.quickLinkBanner;
    }
    return offset;
}

export interface ElementHeights {
    categoryHeader: number; // class section-header
    sectionHeader: number; // class group-header
    sectionPadding: number;
    sectionBottomMargin: number;
    eventCollectionHeader: number; // class details-header
    event: number;
    extendedEvent: number;
    sectionFooter: number;
    eventFooter: number;
}

export interface BannersHeights {
    promotionBanner: number;
    quickLinkBanner: number;
}

export interface HeightConfig {
    normal: ElementHeights;
    withSidebar: ElementHeights;
    banners: BannersHeights;
}

const defaultBannersHeight = {
    quickLinkBanner: 56 + 8, // height + margin
    promotionBanner: 128 + 8, // height + margin
};

const defaultHeightConfig = {
    categoryHeader: 40 + 8,
    sectionHeader: 28,
    sectionPadding: 4,
    sectionBottomMargin: 8,
    eventCollectionHeader: 22,
    event: 52,
    sectionFooter: 28,
    eventFooter: 20,
};

const heightConfigMap = {
    [ScreenWidth.dXl]: {
        normal: defaultHeightConfig,
        withSidebar: defaultHeightConfig,
        banners: defaultBannersHeight,
    },
    [ScreenWidth.erbp]: {
        normal: defaultHeightConfig,
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.dLg]: {
        normal: defaultHeightConfig,
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.dMd]: {
        normal: defaultHeightConfig,
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.dSm]: {
        normal: {
            ...defaultHeightConfig,
            event: 112, // @marko notion says 52 here but css 112
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.dXs]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.tLg]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.tXl]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.tMd]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.tSm]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
    [ScreenWidth.mMd]: {
        normal: {
            ...defaultHeightConfig,
            event: 112,
        },
        withSidebar: {
            ...defaultHeightConfig,
            event: 112,
        },
        banners: defaultBannersHeight,
    },
} as Record<ScreenWidth, HeightConfig>;

export function getElementHeights() {
    const widthBreakpoint = determineWidthBreakpointMin();
    return heightConfigMap[widthBreakpoint] || {
        normal: defaultHeightConfig,
        withSidebar: defaultHeightConfig,
        banners: defaultBannersHeight,
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/eventGrid/constants.ts